export const FEEDBACK_CATEGORIES = [
    'data_error',
    'bug',
    'feature_request',
    'contact_request',
    'other',
];
export const FEEDBACK_STATUSES = [
    'new',
    'in_progress',
    'resolved',
    'dismissed',
];
export const FEEDBACK_RELATED_ENTITY_TYPES = [
    'venue',
    'wine',
    'event',
    'tasting_experience',
];
